/* eslint-disable security/detect-unsafe-regex */
export const validEmailRegExp =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\])|(([a-z\-\d]+\.)+[a-z]{2,}))$/i
/* eslint-enable security/detect-unsafe-regex */

export function isEmailValid(email: string) {
  return !!(email && validEmailRegExp.test(email.trim()))
}
